import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import ru from './ru.json';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: ['en', 'ru'],
    // без этого t() принимает двоеточие в готовой строке за префикс namespace
    nsSeparator: false,
    resources: {
      en: {
        translation: en,
      },
      ru: {
        translation: ru,
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

// изменяем язык в моменте при изменении языка в i18n и загружаем выбранный язык
// i18n.on('languageChanged', (lng) => {
//   moment.locale(lng);
// });

// устанавливаем язык в моменте при инициализации
// moment.locale(i18n.language);
